import { tryInsertionMethod } from "./index107.js";
function tryInsertSpace(space, apartmentIndex, moduleIndex, apartmentArray) {
	const areaResult = tryInsertionMethod(space, apartmentIndex, moduleIndex, apartmentArray, "Area");
	if (areaResult.success || areaResult.outOfBounds !== "SizeX") return areaResult;
	else {
		const sizeXResult = tryInsertionMethod(space, apartmentIndex, moduleIndex, apartmentArray, "SizeX");
		if (sizeXResult.success) return sizeXResult;
		else return {
			success: false,
			outOfBounds: "SizeX"
		};
	}
}
export { tryInsertSpace };

//# sourceMappingURL=index108.js.map